export const getSite = (siteId) => ({ sites }) =>
sites.sitesList.find(({ id }) => id === siteId);